<mbs-modal
  [title]="baseModal.data.title"
  [isCustomModal]="true"
  [showFooter]="true"
  [titleTextOverflow]="true"
  [loading]="isAvailableLicensesLoading"
  class="manage-modal"
  #modal>
  <div modal-body>
    <div class="pb-3">
      {{ 'shared:licenses.manageModal.description' | i18next }}
    </div>
    <mbs-select
      bindLabel="buildName"
      bindValue="buildValue"
      appendTo=".modal-content"
      [(ngModel)]="selectedLicenseType"
      [label]="'shared:common.license' | i18next"
      [items]="licensesTypes | async"
      [placeholder]="'shared:licenses.placeholders:licenses' | i18next"></mbs-select>
  </div>
  <ng-container modalFooter>
    <mbs-button
      type="primary"
      [loading]="loading"
      [disabled]="!selectedLicenseType"
      (click)="manage()"
      >{{ 'shared:licenses.manageModal.submit' | i18next: { format: 'title' } }}
    </mbs-button>
    <mbs-button
      type="secondary"
      data-dismiss="modal"
      (click)="modal.close()"
      >{{ 'shared:licenses.common.cancel' | i18next: { format: 'title' } }}
    </mbs-button>
  </ng-container>
</mbs-modal>
